import React, { useState } from 'react'
import './academic.scss'
import Input from '../../components/common/Input';
import Modal from '../../components/common/Modal';


const timetableData = [
    {
        id: 1,
        className: "10th",
        section: "A",
        date: "2025-06-16",
        from: "09:00",
        to: "10:00",
        monday: { subject: "English", teacher: "Ramesh" },
        tuesday: { subject: "Maths", teacher: "Suresh" },
        wednesday: { subject: "Science", teacher: "Mahesh" },
        thursday: { subject: "Social", teacher: "Kumar" },
        friday: { subject: "Hindi", teacher: "Rajesh" },
        saturday: { subject: "Games", teacher: "Sports Sir" }
    },

    {
        id: 2,
        className: "9th",
        section: "B",
        date: "2025-06-17",
        from: "10:00",
        to: "11:00",
        monday: { subject: "Maths", teacher: "Anil" },
        tuesday: { subject: "English", teacher: "Sunitha" },
        wednesday: { subject: "Physics", teacher: "Kiran" },
        thursday: { subject: "Biology", teacher: "Sravani" },
        friday: { subject: "Computer", teacher: "Naveen" },
        saturday: { subject: "Drawing", teacher: "Prasad" }
    },

    {
        id: 3,
        className: "8th",
        section: "C",
        date: "2025-06-18",
        from: "11:00",
        to: "12:00",
        monday: { subject: "Science", teacher: "Ravi" },
        tuesday: { subject: "Maths", teacher: "Ganesh" },
        wednesday: { subject: "English", teacher: "Harika" },
        thursday: { subject: "Social", teacher: "Deepa" },
        friday: { subject: "Telugu", teacher: "Bhaskar" },
        saturday: { subject: "Library", teacher: "Sujatha" }
    },

    {
        id: 4,
        className: "7th",
        section: "A",
        date: "2025-06-19",
        from: "01:00",
        to: "02:00",
        monday: { subject: "Telugu", teacher: "Venkatesh" },
        tuesday: { subject: "Hindi", teacher: "Suman" },
        wednesday: { subject: "Maths", teacher: "Rakesh" },
        thursday: { subject: "Science", teacher: "Lakshmi" },
        friday: { subject: "English", teacher: "Madhu" },
        saturday: { subject: "Sports", teacher: "Raju" }
    },

    {
        id: 5,
        className: "6th",
        section: "B",
        date: "2025-06-20",
        from: "02:00",
        to: "03:00",
        monday: { subject: "English", teacher: "Harish" },
        tuesday: { subject: "Science", teacher: "Keerthi" },
        wednesday: { subject: "Maths", teacher: "Chandra" },
        thursday: { subject: "Social", teacher: "Aruna" },
        friday: { subject: "Hindi", teacher: "Praveen" },
        saturday: { subject: "Music", teacher: "Kavitha" }
    },

    {
        id: 6,
        className: "5th",
        section: "C",
        date: "2025-06-21",
        from: "03:00",
        to: "04:00",
        monday: { subject: "EVS", teacher: "Suresh" },
        tuesday: { subject: "English", teacher: "Anusha" },
        wednesday: { subject: "Maths", teacher: "Vijay" },
        thursday: { subject: "Telugu", teacher: "Rani" },
        friday: { subject: "GK", teacher: "Mahender" },
        saturday: { subject: "Craft", teacher: "Swapna" }
    }

];
const TimeTable = () => {
    const [form, setForm] = useState({ name: '', code: '', class_obj: '', max_marks: 100, pass_marks: 35, curriculam: '', });
    const [classes, setClasses] = useState([]);
    const [editRow, setEditRow] = useState(null);
    const [timeTableData, setTimeTableData] = useState(timetableData)
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [modalType, setModalType] = useState("add");


    const [selectedRow, setSelectedRow] = useState(null);

    const [filters, setFilters] = useState({
        curriculam: '',
        classe: '',
        sectoion: '',
        date: ''
    })

    const handleFilterChange = (e) => {
        setFilters({
            ...filters, [e.target.value]: e.target.value
        })
    }

    const filteredData = timeTableData.filter((item) => {

        const curriculumMatch =
            !filters.curriculum ||
            item.curriculum === filters.curriculum;

        const classMatch =
            !filters.className ||
            item.className === filters.className;

        const sectionMatch =
            !filters.section ||
            item.section === filters.section;

        const dateMatch =
            !filters.date ||
            item.date === filters.date;

        return (
            curriculumMatch &&
            classMatch &&
            sectionMatch &&
            dateMatch
        );
    });


    const handleTimetableEditChange = (e) => {
        const { name, value } = e.target
        setSelectedRow((prev) => ({
            ...prev, [name]: value
        }))
    }

    const handleSubjectChange = (
        rowId,
        day,
        field,
        value
    ) => {

        setTimeTableData(prev =>
            prev.map(item =>
                item.id === rowId
                    ? {
                        ...item,
                        [day]: {
                            ...item[day],
                            [field]: value
                        }
                    }
                    : item
            )
        );
    };

    const handleChange = (id, field, value) => {
        setTimeTableData((prev) =>
            prev.map((row) =>
                row.id === id
                    ? { ...row, [field]: value }
                    : row
            )
        );
    };

    const handleAddNew = () => {

        setModalType("add");

        setEditData({
            id: Date.now(),

            className: "",
            section: "",
            date: "",

            from: "",
            to: "",

            monday: {
                subject: "",
                teacher: ""
            },

            tuesday: {
                subject: "",
                teacher: ""
            },

            wednesday: {
                subject: "",
                teacher: ""
            },

            thursday: {
                subject: "",
                teacher: ""
            },

            friday: {
                subject: "",
                teacher: ""
            },

            saturday: {
                subject: "",
                teacher: ""
            }
        });

        setShowEditModal(true);
    };

    const handleEditTime = () => {
        if (!timeTableData.length) return;
        setModalType("edit");
        setEditData({
            ...timeTableData[0]
        });
        setShowEditModal(true);
    };

    const handleModalChange = (day, field, value) => {
        setEditData((prev) => ({
            ...prev,

            [day]: {
                ...prev[day],
                [field]: value
            }
        }));
    };

    // const updateTimetable = () => {
    //     setTimeTableData((prev) =>
    //         prev.map((item) =>
    //             item.id === editData.id
    //                 ? editData
    //                 : item
    //         )
    //     );
    //     setShowEditModal(false);
    // };

    const saveTimetable = () => {

        if (modalType === "add") {

            setTimeTableData([
                ...timeTableData,
                editData
            ]);

        } else {

            const updatedRows = timeTableData.map((item) =>
                item.id === editData.id
                    ? editData
                    : item
            );

            setTimeTableData(updatedRows);
        }

        setShowEditModal(false);
    };

    const handleRowEdit = (row) => {
        setEditData(JSON.parse(JSON.stringify(row)));
        setShowEditModal(true);
    };

    const handleEditChange = (field, value) => {
        setEditData({
            ...editData,
            [field]: value
        });
    };

    const handleDayChange = (
        day,
        key,
        value
    ) => {
        setEditData({
            ...editData,
            [day]: {
                ...editData[day],
                [key]: value
            }
        });
    };

    const updateTimetable = () => {

        const updated = timeTableData.map(
            (item) =>
                item.id === editData.id
                    ? editData
                    : item
        );

        setTimeTableData(updated);

        setShowEditModal(false);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-3 col-sm-6">
                    <Input
                        label="Curriculam"
                        name="section"
                        value={form.section}
                        onChange={handleFilterChange}
                        options={[
                            { value: 'ssc', label: 'SSC' },
                            { value: 'cbsc', label: 'CBSC' },
                        ]}
                    />
                </div>
                <div className="col-md-3 col-sm-6">
                    <label>Class</label>
                    <select className="form-select mt-1">
                        <option>Select Class</option>
                        {classes.map(c => <option key={c.id}>{c.name}</option>)}
                    </select>
                </div>
                <div className="col-md-3 col-sm-6">
                    <Input
                        label="Select Section"
                        name="section"
                        // value={form.section}
                        onChange={handleFilterChange}
                        options={[
                            { value: 'A', label: 'A' },
                            { value: 'B', label: 'B' },
                        ]}
                    />
                </div>
                <div className="col-md-3 col-sm-6">
                    <Input
                        label="Date"
                        name="date"
                        type='date'
                        value={form.date}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="">
                <div className="card-header">
                    <span>Timetable</span>
                    <button
                        className="btn-add"
                        onClick={handleAddNew}
                    >
                        <i className="bi bi-plus-circle me-1"></i>
                        Add New
                    </button>
                </div>

                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-bordered timetable-table mb-0">
                            <thead>

                                {/* Date Row */}
                                <tr className="date-header">
                                    <th rowSpan="2">S.No</th>
                                    <th rowSpan="2">Class</th>
                                    <th rowSpan="2">Section</th>
                                    <th colSpan="2">Time</th>
                                    {timeTableData.slice(0, 6).map((item, index) => (
                                        <th key={index}>
                                            {item.date}
                                        </th>
                                    ))}
                                    <th rowSpan="2">Action</th>
                                </tr>
                                {/* Day Row */}
                                <tr className="day-header">
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Monday</th>
                                    <th>Tuesday</th>
                                    <th>Wednesday</th>
                                    <th>Thursday</th>
                                    <th>Friday</th>
                                    <th>Saturday</th>
                                </tr>
                            </thead>
                            <tbody>

                                {timeTableData.map((row, index) => (
                                    <React.Fragment key={row.id}>
                                        {/* Insert Lunch Break only once */}
                                        {index === 2 && (
                                            <tr className="lunch-row">
                                                <td colSpan="3"></td>
                                                <td className="fw-bold">12:30</td>

                                                <td className="fw-bold"> 01:00 </td>
                                                <td colSpan="6" className="text-center lunch-text">
                                                    🍽 LUNCH BREAK
                                                </td>
                                                <td></td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{row.className}</td>
                                            <td>{row.section}</td>
                                            <td>{row.from}</td>
                                            <td>{row.to}</td>
                                            <td>
                                                {row.monday.subject}
                                                <br />
                                                <small>{row.monday.teacher}</small>
                                            </td>
                                            <td>
                                                {row.tuesday.subject}
                                                <br />
                                                <small>{row.tuesday.teacher}</small>
                                            </td>
                                            <td>
                                                {row.wednesday.subject}
                                                <br />
                                                <small>{row.wednesday.teacher}</small>
                                            </td>
                                            <td>
                                                {row.thursday.subject}
                                                <br />
                                                <small>{row.thursday.teacher}</small>
                                            </td>
                                            <td>
                                                {row.friday.subject}
                                                <br />
                                                <small>{row.friday.teacher}</small>
                                            </td>
                                            <td>
                                                {row.saturday.subject}
                                                <br />
                                                <small>{row.saturday.teacher}</small>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-warning btn-sm"
                                                    onClick={() => handleRowEdit(row)}
                                                >
                                                    <i className="bi bi-pencil-square"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </React.Fragment>

                                ))}

                            </tbody>
                        </table>

                    </div>
                </div>
            </div>


            <Modal show={showEditModal}
                onClose={() => setShowEditModal(false)}
                title={
                    modalType === "add"
                        ? "Add Timetable"
                        : "Edit Timetable"
                }
                size="xl"
            >
                {editData && (
                    <>
                        <div className="row">
                            <div className="col-md-3 col-sm-6">
                                <label>Curriculam</label>
                                <select className='form-select'>
                                    <option>Select</option>
                                    <option>SSC</option>
                                    <option>CBSC</option>
                                </select>
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <label>Class</label>
                                <select className='form-select'>
                                    <option>Select</option>
                                    <option>1</option>
                                    <option>2</option>
                                </select>
                            </div>

                            <div className="col-md-3 col-sm-6">
                                <label>Section </label>
                                <select className='form-select'>
                                    <option>Select</option>
                                    <option>A</option>
                                    <option>B</option>
                                </select>
                            </div>
                        </div>

                        <div className='card my-3 bg-light'>
                            <div className='card-body p-0 px-3 border rounded'>
                                <div className="row mb-3 mt-3">
                                    <div className="col-md-4">
                                        <label>Breaks Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editData.lunchBreak?.title || ""}
                                            onChange={(e) =>
                                                setEditData({
                                                    ...editData,
                                                    lunchBreak: {
                                                        ...editData.lunchBreak,
                                                        title: e.target.value
                                                    }
                                                })
                                            }
                                        />
                                    </div>


                                    <div className="col-md-4">
                                        <label>From Time</label>

                                        <input
                                            type="time"
                                            className="form-control"
                                            value={editData.lunchBreak?.from || ""}
                                            onChange={(e) =>
                                                setEditData({
                                                    ...editData,
                                                    lunchBreak: {
                                                        ...editData.lunchBreak,
                                                        from: e.target.value
                                                    }
                                                })
                                            }
                                        />

                                    </div>


                                    <div className="col-md-4">

                                        <label>To Time</label>

                                        <input
                                            type="time"
                                            className="form-control"
                                            value={editData.lunchBreak?.to || ""}
                                            onChange={(e) =>
                                                setEditData({
                                                    ...editData,
                                                    lunchBreak: {
                                                        ...editData.lunchBreak,
                                                        to: e.target.value
                                                    }
                                                })
                                            }
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>

                        {[
                            "monday",
                            "tuesday",
                            "wednesday",
                            "thursday",
                            "friday",
                            "saturday"
                        ].map((day) => (

                            <div className="row mb-3" key={day}>
                                <div className="col-md-2 col-ms-4">
                                    <label className="fw-bold text-capitalize mt-3 text-info">
                                        {day}
                                    </label>
                                </div>
                                <div className="col-md-2 col-ms-4">
                                    <label>Subject</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Subject"
                                        value={
                                            editData[day]
                                                ?.subject || ""
                                        }
                                        onChange={(e) =>
                                            handleModalChange(
                                                day,
                                                "subject",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="col-md-2 col-ms-4">
                                    <label>Teacher Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Teacher"
                                        value={
                                            editData[day]
                                                ?.teacher || ""
                                        }
                                        onChange={(e) =>
                                            handleModalChange(
                                                day,
                                                "teacher",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="col-md-2 col-ms-4">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={editData[day]?.date || ""}
                                        onChange={(e) =>
                                            handleModalChange(
                                                day,
                                                "date",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="col-md-2 col-ms-4">
                                    <label>From Time</label>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={editData[day]?.from || ""}
                                        onChange={(e) =>
                                            handleModalChange(
                                                day,
                                                "from",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="col-md-2 col-ms-4">
                                    <label> To Time</label>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={editData[day]?.to || ""}
                                        onChange={(e) =>
                                            handleModalChange(
                                                day,
                                                "to",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        ))}

                        <div className="text-end mt-4">

                            <button
                                className="btn btn-secondary me-2"
                                onClick={() =>
                                    setShowEditModal(false)
                                }
                            >
                                Cancel
                            </button>

                            <button
                                className={`btn ${modalType === "add"
                                    ? "btn-primary"
                                    : "btn-success"
                                    }`}
                                onClick={saveTimetable}
                            >
                                {modalType === "add"
                                    ? "Save Timetable"
                                    : "Update Timetable"}
                            </button>
                        </div>

                    </>

                )}
            </Modal>
        </div>
    )
}

export default TimeTable